import PropTypes from 'prop-types';
import { BsChevronDown } from 'react-icons/bs';

import { fieldClasses } from '#globalComponents/Forms/fieldStyles';

export default function Select({ error = false, className = '', children, ...props }) {
	return (
		<div className={`relative ${className}`}>
			<select className={fieldClasses('h-10 appearance-none rounded-card pl-4 pr-10', Boolean(error))} {...props}>
				{children}
			</select>
			<BsChevronDown className="pointer-events-none absolute right-4 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-bgBase-700" />
		</div>
	);
}

Select.propTypes = {
	error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	// Applies to the wrapper div; the select itself always fills it.
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
};
